module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10069.e99934fd.jpg";